const DEFAULT_RECAPTCHA_URL = "https://www.google.com/recaptcha/enterprise.js";
function buildRecaptchaUrl(config) {
  const baseUrl = config.scriptUrl || DEFAULT_RECAPTCHA_URL;
  const params = new URLSearchParams();
  params.append("render", config.siteKey);
  if (config.language) {
    params.append("hl", config.language);
  }
  return `${baseUrl}?${params.toString()}`;
}
function isRecaptchaLoaded() {
  return typeof window !== "undefined" && typeof window.grecaptcha?.enterprise !== "undefined";
}
function hasRecaptchaScript() {
  if (typeof document === "undefined") return false;
  const scripts = document.querySelectorAll('script[src*="recaptcha"]');
  return scripts.length > 0;
}
function loadRecaptchaScript(config) {
  return new Promise((resolve, reject) => {
    if (typeof window === "undefined" || typeof document === "undefined") {
      reject(new Error("reCAPTCHA can only be loaded in a browser environment"));
      return;
    }
    if (isRecaptchaLoaded()) {
      resolve();
      return;
    }
    if (hasRecaptchaScript()) {
      const checkInterval = setInterval(() => {
        if (isRecaptchaLoaded()) {
          clearInterval(checkInterval);
          resolve();
        }
      }, 100);
      setTimeout(() => {
        clearInterval(checkInterval);
        if (!isRecaptchaLoaded()) {
          reject(new Error("reCAPTCHA script loading timeout"));
        }
      }, 1e4);
      return;
    }
    const script = document.createElement("script");
    script.src = buildRecaptchaUrl(config);
    script.async = true;
    script.defer = true;
    script.onload = () => {
      const checkReady = () => {
        if (isRecaptchaLoaded()) {
          resolve();
        } else {
          setTimeout(checkReady, 50);
        }
      };
      checkReady();
    };
    script.onerror = () => {
      reject(new Error("Failed to load reCAPTCHA script"));
    };
    document.head.appendChild(script);
  });
}
function removeRecaptchaScript() {
  if (typeof document === "undefined") return;
  const scripts = document.querySelectorAll('script[src*="recaptcha"]');
  scripts.forEach((script) => script.remove());
  if (typeof window !== "undefined" && window.grecaptcha) {
    Reflect.deleteProperty(window, "grecaptcha");
  }
}
function waitForRecaptchaReady() {
  return new Promise((resolve, reject) => {
    if (typeof window === "undefined") {
      reject(new Error("reCAPTCHA can only be used in a browser environment"));
      return;
    }
    if (!isRecaptchaLoaded()) {
      reject(new Error("reCAPTCHA script is not loaded"));
      return;
    }
    window.grecaptcha.enterprise.ready(() => {
      resolve();
    });
  });
}
export {
  isRecaptchaLoaded,
  loadRecaptchaScript,
  removeRecaptchaScript,
  waitForRecaptchaReady
};
//# sourceMappingURL=recaptcha-loader.js.map
